/**
 * Formats a Firestore timestamp to a readable date string
 * @param {Object} timestamp - Firestore timestamp with _seconds property
 * @returns {string} Formatted date string (e.g., "2 Aug 2025") or "N/A"
 */
export const formatDate = (timestamp) => {
  if (!timestamp || !timestamp._seconds) return 'N/A';
  return new Date(timestamp._seconds * 1000).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
};
